import { Checkbox as RadixCheckbox } from "radix-ui";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export type CheckedState = RadixCheckbox.CheckedState;
interface CheckboxProps extends RadixCheckbox.CheckboxProps {}

export function Checkbox({ className, ...rest }: CheckboxProps) {
  return (
    <RadixCheckbox.Root
      {...rest}
      className={twMerge(
        clsx(
          className,
          "size-6 enabled:hover:cursor-pointer disabled:cursor-not-allowed data-disabled:opacity-50",
        ),
      )}
    >
      <RadixCheckbox.Indicator
        forceMount
        className="group relative inline-block size-full"
      >
        <CheckedIcon className="absolute top-0 left-0 size-full transition-opacity group-data-[state=checked]:opacity-100 group-data-[state=unchecked]:opacity-0" />
        <UncheckedIcon className="absolute top-0 left-0 size-full transition-opacity group-data-[state=checked]:opacity-0 group-data-[state=unchecked]:opacity-100" />
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  );
}

interface SubComponentProps {
  className?: string;
}

function CheckedIcon({ className }: SubComponentProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.6 13.4L8.45 11.25C8.26667 11.0667 8.03333 10.975 7.75 10.975C7.46667 10.975 7.23333 11.0667 7.05 11.25C6.86667 11.4333 6.775 11.6667 6.775 11.95C6.775 12.2333 6.86667 12.4667 7.05 12.65L9.9 15.5C10.1 15.7 10.3333 15.8 10.6 15.8C10.8667 15.8 11.1 15.7 11.3 15.5L16.95 9.85C17.1333 9.66667 17.225 9.43333 17.225 9.15C17.225 8.86667 17.1333 8.63333 16.95 8.45C16.7667 8.26667 16.5333 8.175 16.25 8.175C15.9667 8.175 15.7333 8.26667 15.55 8.45L10.6 13.4ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5Z"
        fill="#3F51B5"
      />
    </svg>
  );
}

function UncheckedIcon({ className }: SubComponentProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4Z"
        stroke="#A3ACB7"
        strokeWidth="2"
      />
    </svg>
  );
}
